export const PRE_ENROLLMENT_CHECK_LABEL = "Pre-enrollment Check";

export const PRE_ENROLLMENT_CHECK_TOOLTIP =
  "We have not finished the enrollment check, so locks are not listed yet. Release this device from MDM, ABM, and iCloud.";

export function initialReportActionCopy(hours: number): string {
  return `Download the report for the full device list. Each device stays in ${PRE_ENROLLMENT_CHECK_LABEL} until we finish the enrollment check, so the report does not list locks yet. Release every device from MDM, ABM, and iCloud within ${hours} hours. That release is the action for this pickup.`;
}
